export enum WidgetType {
    AQ_CO2 = 'WidgetCO2',
    TEMPERATURE = 'WidgetTemperature',
    HUMIDITY = 'WidgetHumidity',
    PRESSURE = 'WidgetPressure',
    HISTOGRAM = 'WidgetHistogram',
    MORE_INFO = 'WidgetMoreInformation',
    ICONE = 'WidgetIcone',
    STATIONS = 'WidgetStationList',
    MAP = "WidgetMap",
    AERO_SCORE = "WidgetAeroScore",
    DISTRIBUTION = "WidgetDistribution",
}

export interface Widget {
    id: string;
    width: number;
    height: number;
    minWidth: number;
    minHeight: number;
    x: number;
    y: number;
    type: WidgetType;
}